// Injection d'une icon svg
export function svgstore(name, className = '') {
    const classes = ['svg']
    classes.push(className == '' ? name : className)
    return `<svg class="${classes.join(
        ' '
    )}" aria-hidden="true"><use xlink:href="#${name}"></use></svg>`
}
